import { get } from 'lodash';

export default function IvrService(userService, apiService, popupService, $log) {
  'ngInject';

  const getParams = user => {
    if (!user) {
      return null;
    }

    const userId = user.userId;
    const phones = user.phoneNumbers;
    const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
      userId,
      phones,
      timezone,
    };
  };

  const fetchNeedPopup = id => {
    const params = getParams(userService.user);

    if (!params || !id) {
      return Promise.resolve(false);
    }

    return apiService
      .needPopupForIvr({
        offerId: id,
        ...params,
      })
      .then(response => {
        return get(response, 'data.status');
      })
      .catch(err => {
        $log.error(err);

        return false;
      });
  };

  const showPopup = () => popupService.openPopup('ivrRemind');

  return {
    fetchNeedPopup,
    showPopup,
  };
}
